import React, { useState, useEffect } from 'react';
import { Title } from '..';
import './CategoriesSlider.css';
import CategoryCard from '../CategoryCard/CategoryCard';
import { useLocation, useNavigate } from 'react-router-dom';
import { getCategorySlug } from '../../utils/Utils';

const CategoriesSlider = ({ contentLng, endPoint }) => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      // Get the top position of the 'categories' div
      const categoriesElement = document.querySelector('.categories');
      const categoriesTop = categoriesElement.getBoundingClientRect().top;
      // Calculate the threshold based on viewport height and navbar height
      // const threshold = window.innerHeight - 58;

      // Check if the top of the 'categories' div is within the viewport and below the threshold
      if (categoriesTop < 60 && window.scrollY > 0) {
        // setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Remove event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleCategoryClick = (categoryName) => {
    const categorySlug = getCategorySlug(categoryName);
    
    if (isHomePage) {
      // Scroll to category section on home page
      const categoryElement = document.getElementById(categorySlug);
      if (categoryElement) {
        const offset = 80; // Offset for fixed navbar
        const elementPosition = categoryElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    } else {
      // Navigate to products page if not on home page
      navigate(`/${categorySlug}`);
    }
  };

  return (
    <div className='CategoriesSlider'>
      <Title category={{ "name": contentLng.catTitle, "desc": contentLng.catDesc }} />
      <div className={`categories ${isVisible ? 'fixed' : ''}`} style={{ display: 'flex', width: '100%', overflowX: 'auto' }}>
        {contentLng.categories.map((category, i) => (
          <div 
            key={i} 
            style={{ flex: '0 0 auto', width: isVisible ? '25%' : '33%', marginRight: '10px', cursor: 'pointer' }}
            onClick={() => handleCategoryClick(category.name)}
          >
            <CategoryCard category={category} endPoint={endPoint} isVisible={isVisible} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoriesSlider;
